module.exports = __webpack_public_path__ + "static/media/brackets.30f84cd2.svg";